import React from "react";
import { useTranslation } from "react-i18next";
import RoundButton from "../../Buttons/RoundButton";
import classes from "./CardGame.module.scss";

export default function CardGame({
  className = "",
  id = "",
  name = "",
  image = "",
  abilities = null,
  onClick = null,
}: {
  abilities: any;
  name: string | null;
  image: string | null;
  className?: string;
  id: string;
  onClick: any;
}) {
  const { t } = useTranslation();
  className += "  " + classes.CardGame;
  return (
    <article className={className} key={id}>
      <div
        className={classes.GameImg}
        style={{ backgroundImage: `url(${image})` }}
      />
      <div className={classes.GameInfos}>
        <h1 className={classes.Title}>{name}</h1>
        <h2 className={classes.SubTitle}>{t("global.you_will_training")}:</h2>
        <ul>
          {abilities &&
            abilities.map((ability: string) => (
              <li className={classes.Info} key={ability}>
                - {ability}
              </li>
            ))}
        </ul>
        <div className={classes.BtnsArea}>
          <RoundButton
            extraSmall
            text={t("global.play")}
            title={t("global.open_game_modal")}
            onClick={onClick}
          />
        </div>
      </div>
    </article>
  );
}
